import { Loading } from '@components/common';
import { useAtom, useAtomValue } from 'jotai';
import React from 'react';
import { appAccountsDetailsAtom, videoAccountsDetailsAtom, apiAccountsDetailsAtom } from '../atoms';
import AppMetricsPanel from './AppMetricsPanel/AppMetricsPanel';
import VideoMetricsPanel from './VideoMetricsPanel/VideoMetricsPanel';
import ApiMetricsPanel from './ApiMetricsPanel/ApiMetricsPanel';

const MetricsPanel = ({ isCustomerListFetching }) => {
  const videoAccountDetails: any = useAtomValue(videoAccountsDetailsAtom);
  const appAccountDetails: any = useAtomValue(appAccountsDetailsAtom);
  const apiAccountDetails: any = useAtomValue(apiAccountsDetailsAtom);

  if (isCustomerListFetching) {
    return <Loading></Loading>;
  }
  return (
    <div>
      {videoAccountDetails.length ? <VideoMetricsPanel /> : ''}
      {appAccountDetails.length ? <AppMetricsPanel /> : ''}
      {apiAccountDetails.length ? <ApiMetricsPanel /> : ''}
    </div>
  );
};
export default MetricsPanel;
